<template>
  <div>
    <div class="modal-header has-background-info-light">
      <h2 class="window-header subtitle">{{ title }}</h2>
    </div>
    <div class="box">
      <!-- Tabs for switching between user info and departments -->
      <div class="tabs is-boxed" v-if="!addOrEdit && selectedUser.userId">
        <ul>
          <li :class="{ 'is-active': activeTab === 'info' }">
            <a @click="activeTab = 'info'">
              <span class="icon is-small"
                ><font-awesome-icon icon="user"
              /></span>
              <span>Osnovni podaci</span>
            </a>
          </li>
          <li :class="{ 'is-active': activeTab === 'departments' }">
            <a @click="activeTab = 'departments'">
              <span class="icon is-small"
                ><font-awesome-icon icon="building"
              /></span>
              <span>Sektori</span>
            </a>
          </li>
          <li :class="{ 'is-active': activeTab === 'reports' }">
            <a @click="activeTab = 'reports'">
              <span class="icon is-small"
                ><font-awesome-icon icon="chart-bar"
              /></span>
              <span>Reporti</span>
            </a>
          </li>
        </ul>
      </div>

      <!-- User Info Tab -->
      <div v-show="activeTab === 'info' || addOrEdit">
        <!-- ime i prezime -->
        <div class="columns">
          <div class="column has-text-centered"><label>Korisnik:</label></div>
          <div class="column has-text-centered is-four-fifths">
            <vue-select
              :disabled="selectingEmployeeDisabled"
              class="has-background-info-light"
              type="text"
              label="name"
              :clearable="false"
              :options="activeEmployees"
              v-model="connectedEmployee"
            />
          </div>
        </div>
        <!-- broj telefona -->
        <div class="columns">
          <div class="column">
            <p>Telefon</p>
            <input
              class="input has-text-centered has-background-info-light"
              type="text"
              placeholder="samo cifre - 069XXXXXX"
              v-model="selectedUser.phone"
            />
          </div>
        </div>
        <!-- nivo privilegija -->
        <div class="columns">
          <div class="column">
            <p>Nivo privilegija</p>
            <vue-select
              class="ev-select has-background-info-light"
              :options="privilegeLevelOptions"
              label="name"
              :reduce="(option) => option.id"
              v-model="selectedUser.privilegeLevel"
              :clearable="false"
              placeholder="Odaberite nivo privilegija"
            >
              <template #option="{ name, description }">
                <div class="privilege-option">
                  <strong>{{ name }}</strong>
                  <span class="privilege-description">{{ description }}</span>
                </div>
              </template>
            </vue-select>
          </div>
        </div>
        <!-- Korisničko ime i šifra-->
        <div v-if="addOrEdit">
          <p>Korisničko ime i šifra biće generisani</p>
          <p>a zatim poslati SMS-om na gore navedeni broj telefona</p>
        </div>
        <div class="columns" v-if="!addOrEdit">
          <div class="column">
            <p>Korisničko ime</p>
            <input
              class="input has-text-centered has-background-info-ligth"
              type="text"
              disabled
              v-model="selectedUser.userName"
            />
          </div>
        </div>
        <!-- Should regenerate username & password -->
        <div class="column" v-if="!addOrEdit">
          <div class="has-text-centered">
            <label
              >Da li da generišem novo korisničko ime i šifru i pošaljem
              SMS-om?</label
            >
          </div>
          <div class="is-four-fifths">
            <input
              class="has-text-weight-bold has-text-centered has-background-info-light"
              type="checkbox"
              v-model="selectedUser.shouldRegenerateCredentials"
            />
          </div>
        </div>
        <div class="columns">
          <div v-show="isSaveAndProceedButtonVisible" class="column">
            <button
              :disabled="!canProceed(selectedUser)"
              class="button is-info is-light is-rounded"
              @click="saveAndProceedButtonClicked"
            >
              SAČUVAJ I NASTAVI
            </button>
          </div>
          <div class="column">
            <button
              :disabled="!canProceed(selectedUser)"
              class="button is-info is-light is-rounded"
              @click="saveAndCloseButtonClicked"
            >
              SAČUVAJ I ZATVORI
            </button>
          </div>
        </div>
      </div>

      <!-- Departments Tab -->
      <div
        v-show="
          activeTab === 'departments' && !addOrEdit && selectedUser.userId
        "
      >
        <edit-user-departments
          :userId="selectedUser.userId"
          :departments="departments"
        />
      </div>

      <!-- Reports Tab -->
      <div
        v-show="activeTab === 'reports' && !addOrEdit && selectedUser.userId"
      >
        <edit-user-reports
          :userId="selectedUser.userId"
          :availableReports="availableReports"
        />
      </div>
    </div>
  </div>
</template>

<script>
import "vue2-datepicker/index.css";
import EditUserDepartments from "./EditUserDepartments.vue";
import EditUserReports from "./EditUserReports.vue";
import { getPrivilegeLevelOptions } from "../../_helpers/privilegeLevels.js";

export default {
  name: "EditUser",

  components: {
    EditUserDepartments,
    EditUserReports,
  },

  props: {
    button1Name: String,
    button2Name: String,
    title: String,
    selectedUser: Object,
    selectingEmployeeDisabled: Boolean,
    addOrEdit: Boolean,
    departments: Array,
    availableReports: Array,
    isSaveAndProceedButtonVisible: Boolean,
  },

  data() {
    return {
      activeEmployees: [],
      connectedEmployee: {},
      activeTab: "info",
      privilegeLevelOptions: getPrivilegeLevelOptions(),
    };
  },
  mounted() {
    console.log("mounted");
    this.selectedUser.companyId = this.$store.state.general.companyId;

    // calculate connectedEmployee
    this.activeEmployees = this.$store.state.general.employees;
    this.connectedEmployee = this.activeEmployees.find(
      (e) => e.id == this.selectedUser.employeeId
    );

    // set priviledge level to 1
    if (this.selectedUser.privilegeLevel == null)
      this.selectedUser.privilegeLevel = 1;

    // set should regenerate credentials to false because server won't accept null
    this.selectedUser.shouldRegenerateCredentials = false;

    // Reset tab to info when component is mounted
    this.activeTab = "info";
  },
  watch: {
    selectedUser: {
      handler() {
        // Reset tab to info when user changes
        this.activeTab = "info";
      },
      deep: false,
    },
  },
  methods: {
    saveAndProceedButtonClicked() {
      this.arrangeResult();
      this.$emit("saveAndProceedClicked", this.selectedUser);
      this.connectedEmployee = null;
      this.selectedUser.phone = "";
      console.log(this.selectedUser);
    },
    saveAndCloseButtonClicked() {
      this.arrangeResult();
      this.$emit("saveAndCloseClicked", this.selectedUser);
      console.log(this.selectedUser);
    },

    arrangeResult() {
      const nameParts = this.getEmployeeNameParts();

      this.selectedUser.employeeId = this.connectedEmployee.id;
      this.selectedUser.firstName = nameParts.firstName;
      this.selectedUser.lastName = nameParts.lastName;
      this.selectedUser.twoFactorEnabled = false;
    },

    getEmployeeNameParts() {
      const name = this.connectedEmployee && this.connectedEmployee.name;
      const nameParts =
        typeof name === "string" ? name.trim().split(/\s+/) : [];

      return {
        firstName: nameParts[0] || "",
        lastName: nameParts.slice(1).join(" "),
      };
    },

    canProceed(selectedUser) {
      let isnumPhone = false;

      if (selectedUser == null) {
        return false;
      } else {
        isnumPhone = /^\d+$/.test(selectedUser.phone);
      }

      if (selectedUser.phone == null || selectedUser.phone == "") {
        return false;
      } else if (!isnumPhone) {
        return false;
      }

      const nameParts = this.getEmployeeNameParts();
      if (!nameParts.firstName || !nameParts.lastName) {
        return false;
      }

      // Privilege level is now selected from dropdown, just check if it's set
      if (
        selectedUser.privilegeLevel == null ||
        selectedUser.privilegeLevel === ""
      ) {
        return false;
      }

      return true;
    },
  },
};
</script>

<style scoped>
.privilege-option {
  display: flex;
  flex-direction: column;
  padding: 4px 0;
}

.privilege-option strong {
  font-size: 14px;
  color: #1e293b;
}

.privilege-description {
  font-size: 12px;
  color: #64748b;
  margin-top: 2px;
}

.ev-select {
  width: 100%;
}
</style>
